<template>
	<!-- 	<div class="fourth">

		<div
			style="width: 100%;height: 10rem;background-color: black;position: absolute;z-index: 1;margin-top:1rem;overflow: hidden;text-align: center;">
			<el-carousel indicator-position="none" height="62rem">
				<el-carousel-item v-for="item in zmd" :key="item.path">
					<el-image :src="item.path" fit="fill"></el-image>
				</el-carousel-item>

			</el-carousel>
			<div style="color: gray;float: left;margin-left: 46.5rem;margin-top: 1rem;">
				联系我们 : 0411-87588091&nbsp;0411-87588320&nbsp;13942048140&nbsp;<br>
				辽ICP备2023010852号-1
			</div>
			<div style="margin-left: 19rem; height: 7rem;width: 7rem;float: left;color: gray; margin-top: 0.6rem;">
				<img src="../assets/image/gongzhonghao.jpg" height="100%" width="100%" title="微信公众号">
			</div>
		</div>
	</div> -->

	<div>


		<div
			style="width: 100%;height: 53.6rem;background-color: black;position: absolute;z-index: 1;overflow: hidden;color: white;text-align: center;">
			<!-- 			<el-carousel indicator-position="none" height="62rem">
							<el-carousel-item v-for="item in zmd1" :key="item">
					<el-image :src="item" fit="fill"></el-image>
				</el-carousel-item>

			</el-carousel> -->

			<el-carousel type="card" indicator-position="none" height="42rem" style="background-color: #fff; ">
				<el-carousel-item v-for="item in zmd1" :key="item" style="background-color: #fff; ">

					<el-image style="height: 42rem;background-color: #fff; " :src="item" fit="contain"
						:preview-src-list="zmd1"></el-image>

				</el-carousel-item>
			</el-carousel>
		</div>

		<div
			style="width: 100%;height: 7rem;background-color: black;position: absolute;z-index: 1;margin-top:44rem;overflow: hidden;text-align: center;">
			<div style="color: gray;float: left;margin-left: 46.5rem;margin-top: 1rem;">
				联系我们 : 0411-87588091&nbsp;0411-87588320&nbsp;13942048140&nbsp;<br>
				辽ICP备2023010852号-1
			</div>

			<div style="margin-left: 19rem; height: 7rem;width: 7rem;float: left;color: gray;">
				<img src="../assets/image/gongzhonghao.jpg" height="100%" width="100%" title="微信公众号">
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'Fourth',
		props: {
			msg: String
		},
		data() {
			return {
				bj: require("../assets/image/2.png"),
				zmd: [{
						path: "http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-08-13.png"
					},
					{
						path: "http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-09-16.png"
					},
					{
						path: "http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-12-22.png"
					},
					{
						path: "http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-12-32.png"
					},
					{
						path: "http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-12-42.png"
					},
				],
				zmd1: [
					"http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-08-13.png",
					"http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-09-16.png",
					"http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-12-22.png",
					"http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-12-32.png",
					"http://114.116.47.165:12345/about/Snipaste_2024-10-10_14-12-42.png",
				]
			}
		},

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	h3 {
		margin: 40px 0 0;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}
</style>